import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const Payees = () => {
  const update = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/payees/${id}`, data)
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });
  const remove = (id, data) =>
    AuthAxios.delete(`${DataApiUrl}/payees/${id}`, data)
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });
  const search = term =>
    AuthAxios.get(`${DataApiUrl}/payees?search=${term}`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  return { update, remove, search };
};

export default Payees;
